import React, { useEffect, useState, useRef } from "react";
import { Outlet, Link, useLocation } from 'react-router-dom';
import { PUBLIC_SWAGGER_URL } from "../../Configs";

export const APIReference = props => {

    const [activeMainLink, setActiveMainLink] = useState("overview");
    const [activeLink, setActiveLink] = useState('');
    const [targetElement, setTargetElement] = useState(null);
    const menuRef = useRef(null);

    useEffect(() => {
        const sidebarToggler = document.getElementById('docs-sidebar-toggler');
        const sidebar = document.getElementById('docs-sidebar');
        const sidebarLinks = document.querySelectorAll('#docs-sidebar .nav-link');

        /* ===== Responsive Sidebar ====== */
        let w = window.innerWidth;
        if (w >= 1200) {
            sidebar.classList.remove('sidebar-hidden');
            sidebar.classList.add('sidebar-visible');

        } else {
            sidebar.classList.remove('sidebar-visible');
            sidebar.classList.add('sidebar-hidden');
        }

        sidebarToggler.addEventListener('click', () => {
            if (sidebar.classList.contains('sidebar-visible')) {
                sidebar.classList.remove('sidebar-visible');
                sidebar.classList.add('sidebar-hidden');

            } else {
                sidebar.classList.remove('sidebar-hidden');
                sidebar.classList.add('sidebar-visible');
            }
        });

        sidebarLinks.forEach((sidebarLink) => {
            sidebarLink.addEventListener('click', (e) => {
                //Collapse sidebar after clicking
                if (sidebar.classList.contains('sidebar-visible') && window.innerWidth < 1200) {
                    sidebar.classList.remove('sidebar-visible');
                    sidebar.classList.add('sidebar-hidden');
                }
            });
        });
    }, [])


    const location = useLocation();

    useEffect(() => {
        // Trigger the parent component action when the route changes
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.75, // Adjust this value based on your preference
        };

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                const linkId = entry.target.getAttribute('id');
                if (!(linkId == null || linkId === undefined)) {
                    if (linkId.length > 0) {
                        if (entry.isIntersecting) {
                            setActiveLink(linkId);
                        }
                    }
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        const linkElements = menuRef.current?.querySelectorAll('a');
        linkElements.forEach((link) => {
            const linkId = link.getAttribute('href');
            if (!(linkId == null || linkId === undefined)) {
                var targets = linkId.split("#")
                var targetId = ""
                if (targets.length > 1) {
                    targetId = targets[1]
                }
                if (targetId.length > 0) {
                    const targetElement = document.querySelector("#" + targetId);
                    if (targetElement) {
                        observer.observe(targetElement);
                    }
                }
            }
        });

        if (location !== null) {
            if (location.hash !== '') {
                const targetElement = document.querySelector(location.hash);
                if (targetElement) {
                    setActiveLink(location.hash);
                    setTargetElement(targetElement)
                }
            } else {
                setActiveLink(location.hash);
                window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
            const mainPage = location.pathname.replace("/", "");
            setActiveMainLink(mainPage)
        }

        // Cleanup the observer when the component unmounts
        return () => {
            observer.disconnect();
        };
        // Perform any necessary logic or state updates
    }, [location]);

    useEffect(() => {
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    }, [targetElement])


    return (
        <>
            <div className="docs-wrapper" style={{borderLeft:"8px solid orange"}}>
                <div id="docs-sidebar" className="docs-sidebar">
                    <div className="top-search-box d-lg-none p-3">
                        <form className="search-form">
                            <input type="text" placeholder="Search the docs..." name="search" className="form-control search-input" />
                            <button type="submit" className="btn search-btn" value="Search"><i className="fas fa-search"></i></button>
                        </form>
                    </div>
                    <nav id="docs-nav" className="docs-nav navbar" ref={menuRef}>
                        <ul className="section-items list-unstyled nav flex-column pb-3">
                            <li className="nav-item section-title">
                                <span style={{color:"orange", fontSize:"18px"}}>Online API</span>
                            </li>
                            <li className="nav-item section-title">
                                <Link className={activeMainLink === 'overview' ? 'nav-link active' : 'nav-link'} to="/online-api/overview" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-map-signs"></i></span>
                                    Overview
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'getting-started' ? 'nav-link active' : 'nav-link'} to="/online-api/getting-started" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-rocket"></i></span>
                                    Getting Started
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'environments' ? 'nav-link active' : 'nav-link'} to="/online-api/environments" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-globe"></i></span>
                                    Environments
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'metadata' ? 'nav-link active' : 'nav-link'} to="/online-api/metadata" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-file-code"></i></span>
                                    Metadata
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'terminal-onboarding' ? 'nav-link active' : 'nav-link'} to="/online-api/terminal-onboarding" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-arrow-down"></i></span>
                                    Terminal Onboarding
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'link-terminal' ? 'nav-link active' : 'nav-link'} to="/online-api/terminal-onboarding#link-terminal" relative="path">
                                    Link Request
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'unlink-terminal' ? 'nav-link active' : 'nav-link'} to="/online-api/terminal-onboarding#unlink-terminal" relative="path">
                                    Unlink Request
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'transaction-requests' ? 'nav-link active' : 'nav-link'} to="/online-api/transaction-requests" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-box"></i></span>
                                    Transaction Requests
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'create-payment-request' ? 'nav-link active' : 'nav-link'} to="/online-api/transaction-requests#create-payment-request" relative="path">
                                    Create Payment Request
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'retreive-payment-request' ? 'nav-link active' : 'nav-link'} to="/online-api/transaction-requests#retreive-payment-request" relative="path">
                                    Retreive Payment Request
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'cancel-payment-request' ? 'nav-link active' : 'nav-link'} to="/online-api/transaction-requests#cancel-payment-request" relative="path">
                                    Cancel Payment Request
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'refund-request' ? 'nav-link active' : 'nav-link'} to="/online-api/transaction-requests#refund-request" relative="path">
                                    Refund Request
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'reverse-request' ? 'nav-link active' : 'nav-link'} to="/online-api/transaction-requests#reverse-request" relative="path">
                                    Reverse Request
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'print-receipt' ? 'nav-link active' : 'nav-link'} to="/online-api/transaction-requests#print-receipt" relative="path">
                                Print Request
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'reporting' ? 'nav-link active' : 'nav-link'} to="/online-api/reporting" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-cogs"></i></span>
                                    Reporting
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'last-transaction' ? 'nav-link active' : 'nav-link'} to="/online-api/reporting#last-transaction" relative="path">
                                    Last Transaction
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'transaction-report' ? 'nav-link active' : 'nav-link'} to="/online-api/reporting#transaction-report" relative="path">
                                    Transaction Report
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'error-handling' ? 'nav-link active' : 'nav-link'} to="/online-api/error-handling" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-tools"></i></span>
                                    Error Handling
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className={activeMainLink === 'features' ? 'nav-link active' : 'nav-link'} to="/online-api/features" relative="path">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-credit-card"></i></span>
                                    Features
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className={activeLink === 'CNA' ? 'nav-link active' : 'nav-link'} to="/online-api/features#CNA" relative="path">
                                   Card Number Alias
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className='nav-link' to="/simulator" relative="path" target="_blank" rel="noreferrer">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-laptop-code"></i></span>
                                    Online API Simulator
                                </Link>
                            </li>
                            <li className="nav-item section-title mt-3">
                                <Link className='nav-link' to="/demo" relative="path" target="_blank" rel="noreferrer">
                                    <span className="theme-icon-holder me-2"><i className="fas fa-cart-shopping"></i></span>
                                    Online API Demo Store
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div className="docs-content">
                    <div className="container">
                        <Outlet />
                        <footer className="footer">
                            <div className="container text-center py-5">

                            </div>
                        </footer>
                    </div>
                </div>
            </div>
            <div className="docs-top-utilities d-flex justify-content-end align-items-center">
                <a href="/simulator" target="_blank" rel="noreferrer"
                    className="btn btn-primary btn-simulator d-none d-lg-flex" role="button" aria-disabled="true">Simulator</a>
            </div>
            <div className="docs-top-utilities d-flex justify-content-end align-items-center">
                <a href={PUBLIC_SWAGGER_URL + "/in-store/swagger/index.html"} target="_blank" rel="noreferrer"
                    className="btn btn-primary btn-swagger d-none d-lg-flex" role="button" aria-disabled="true">Swagger</a>
            </div>
        </>
    );
};
